import { render } from "./ProductsPhoto.vue?vue&type=template&id=746cf67c"
import script from "./ProductsPhoto.vue?vue&type=script&lang=js"
export * from "./ProductsPhoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__